import type { RouteLocation } from 'vue-router';
import type { AgentTools } from '../runtime/types/tools';
import { AgentToolsRegistry } from '../runtime/utils/agentToolsRegistry';

export default defineNuxtPlugin({
    name: 'tools',
    dependsOn: ['nuxt:router'],
    async setup()
    {
        const { $router } = useNuxtApp();
        const store = useAuthStore();
        const registry = new AgentToolsRegistry(() => ({ loaded: store.loaded, authenticated: store.authenticated }));

        // Zmiana widoku (nazwy trasy) czyści poziom ulotny - parametry/query tej samej trasy nie liczą
        // się jako zmiana widoku, tak samo jak w guard.ts
        $router.afterEach((to: RouteLocation, from: RouteLocation) =>
        {
            if (to.name != from?.name)
            {
                registry.clearEphemeral();
            }
        });

        // Wylogowanie w SPA nie przeładowuje strony, a token potrafi wygasnąć sam bez wywołania akcji
        // wylogowania - sygnałem jest więc przejście stanu sesji z zalogowanej na niezalogowaną
        watch(() => store.authenticated, (value, previous) =>
        {
            if (previous === true && value === false)
            {
                registry.clearEphemeral();
            }
        });

        // Wołający spoza aplikacji (agent sterujący przeglądarką) potrzebuje realnego window; SPA bez
        // SSR sprawia, że w panelu warunek jest zawsze prawdziwy, ale bez niego montowanie wysypywałoby
        // się w środowisku bez DOM
        if (typeof window !== 'undefined')
        {
            // Na window ląduje obiekt zawężony do pięciu metod kontraktu, a nie instancja rejestru -
            // sam interfejs zawęża tylko typ, więc clearEphemeral byłoby wołalne z konsoli przeglądarki
            const contract: AgentTools = {
                registerTool: registry.registerTool.bind(registry),
                registerPrompt: registry.registerPrompt.bind(registry),
                registerResource: registry.registerResource.bind(registry),
                list: registry.list.bind(registry),
                call: registry.call.bind(registry)
            };

            window.edito = window.edito || {};
            window.edito.tools = contract;
        }
    }
});

declare global
{
    interface Window
    {
        edito?: {
            tools?: AgentTools;
        };
    }
}
